module.exports = "https://health.dajiuxing.com.cn/img/assets/img/integral_img2.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fintegral_img2.png
// module id = pHbm
// module chunks = 93